import { render } from "./category-create-input.vue?vue&type=template&id=36dc496c&scoped=true"
import script from "./category-create-input.vue?vue&type=script&lang=js"
export * from "./category-create-input.vue?vue&type=script&lang=js"

import "./category-create-input.vue?vue&type=style&index=0&id=36dc496c&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dc496c"]])

export default __exports__